import axios from "axios";
import { ADVISER_IDENTIFIER, ANALYTICS_API_URL, ANSWERS_API_URL, SENDGRID_SERVICE_URL } from "../../env";

const config = {
  headers: {
    "Content-Type": "application/json"
  }
};

export const sendNotificationEmail = (body: any) => {
  return axios.post(`${SENDGRID_SERVICE_URL}`, body, config)
}

export const uploadCommentRequest = (body: any) => {
  return axios.post(`${ANSWERS_API_URL}/${ADVISER_IDENTIFIER}/answers/comments/`, body, config)
}

export const uploadEventRequest = (data: any, adviserCode: string) => {
  return axios.post(`${ANALYTICS_API_URL}/${btoa(adviserCode || "")}/analytics/new/`, data, config)
}